import { STYX_THEME } from "../../styles/theme";
import type { BootItem } from "../types";
import type { BootKey, BootStateRow } from "./domainTypes";

export type BootAction =
  | { type: "boot-update"; key: BootKey; state: BootItem["state"]; detail?: string }
  | { type: "boot-reset" }
  | { type: "boot-hide" }
  | { type: "session-reset" };

export const BOOT_FLOW: ReadonlyArray<{ key: BootKey; label: string }> = [
  { key: "sodium", label: STYX_THEME.bootSteps[0] },
  { key: "vault", label: STYX_THEME.bootSteps[1] },
  { key: "format", label: STYX_THEME.bootSteps[2] },
  { key: "relay", label: STYX_THEME.bootSteps[3] },
  { key: "auth", label: STYX_THEME.bootSteps[4] },
];

export function createBootItems(): BootStateRow[] {
  return BOOT_FLOW.map((item, index) => ({
    key: item.key,
    label: item.label,
    state: index === 0 ? "active" : "pending",
  }));
}

export type AuthBootState = {
  bootItems: BootStateRow[];
  bootVisible: boolean;
};

export function initialBootState(): AuthBootState {
  return {
    bootItems: createBootItems(),
    bootVisible: true,
  };
}

export function bootReducer(state: AuthBootState, action: BootAction): AuthBootState {
  switch (action.type) {
    case "boot-update":
      return {
        ...state,
        bootItems: state.bootItems.map((item) =>
          item.key === action.key ? { ...item, state: action.state, detail: action.detail } : item,
        ),
      };
    case "boot-reset":
      return {
        ...state,
        bootItems: createBootItems(),
        bootVisible: true,
      };
    case "boot-hide":
      return { ...state, bootVisible: false };
    case "session-reset":
      return {
        bootItems: state.bootItems,
        bootVisible: false,
      };
    default:
      return state;
  }
}
